<template>
  <div class="light-apply">
    <div class="light3-tip">{{ lightTips }}</div>
    <personInfo
      v-for="(item, index) in displayInfo.prayerList"
      :key="index"
      :prayerInfo="item"
      :prayerIndex="index"
      :totalCount="displayInfo.prayerList.length"
      :lightInfo="lightInfo"
      :givewayInfo="givewayInfo"
      :firstAddrs="displayInfo.prayerList[0].address"
      :firstPhone="displayInfo.prayerList[0].phone"
      :lightsChange="countLights()"
      ref="personInfo"
      :isRecord="false"
    >
    </personInfo>
    <div class="light-person-btn">
      <div
        :class="[
          'light-person light-person-sub',
          displayInfo.prayerList.length <= 1
            ? 'light-person-sub light-person-disable'
            : '',
        ]"
        @click="subPerson"
      >
        少一人
      </div>
      <div
        :class="[
          'light-person light-person-add',
          displayInfo.prayerList.length >= 9
            ? 'light-person-add light-person-disable'
            : '',
        ]"
        @click="addPerson"
      >
        多一人
      </div>
    </div>

    <div class="light-giveway">已選燈數共 {{ lightsCount }} 盞 (每點一盞燈，可獲得點數 1 點)</div>

    <givewayInfo
      :prayerInfo="displayInfo.prayerList[0]"
      :givewayInfo="givewayInfo"
      :lightsCount="lightsCount"
      @updateGiveway="updateGiveway($event)"
      ref="givewayInfo"
    >
    </givewayInfo>

    <div class="light-footer-steps">
      <div
        class="temple-button-text light-footer-previous"
        @click="previousClick"
      >
        上一步
      </div>
      <div class="temple-button-text light-footer-next" @click="nextClick">
        下一步
      </div>
    </div>
  </div>
</template>

<script scoped>
import store from 'Store/store';
import personInfo from 'Pages/ServiceModule/ServiceLight/ServiceLightPersonInfo.vue';
import givewayInfo from 'Pages/ServiceModule/ServiceLight/ServiceLightGiveway.vue';
import scrollToElement from 'scroll-to-element';

export default {
  name: 'ServiceLightStep3',
  components: { personInfo, givewayInfo },
  data() {
    return {
      info: {},
      lightsCount: 0,
      errorText: {},
    };
  },
  beforeMount() {
    this.info = this.applyInfo;
    if (
      this.info.prayerList[0].name === '' ||
      this.info.prayerList[0].name === undefined
    ) {
      this.info.prayerList[0].name = store.state.main.lightApplyInfo.applyName;
    }

    if (
      this.info.prayerList[0].phone === '' ||
      this.info.prayerList[0].phone === undefined
    ) {
      this.info.prayerList[0].phone =
        store.state.main.lightApplyInfo.applyPhone;
    }
  },
  mounted() {},
  methods: {
    countLights() {
      let count = 0;

      this.info.prayerList.forEach((prayer) =>
        prayer.lightTypes.forEach(() => count++)
      );

      this.lightsCount = count;
    },
    previousClick() {
      this.$emit('previousStep');
    },
    nextClick() {
      this.validateFormat() && this.validateLogic() && this.goNextStep();
    },
    goNextStep() {
      this.info.price = this.getPrice();
      this.info.fare = this.getFare();

      this.info.paymentType = Number(this.payWay);
      this.info.serviceId =
        store.state.main.onlineStatus.lightInfo.serviceInfo.id;
      this.info.policyId = store.state.main.onlineStatus.policyInfo.id;
      store.dispatch('main/modifyLightApplyInfo', this.info);
      this.$emit('nextStep');
    },
    // 參數格式是否正確
    validateFormat() {
      let checkResults = [];
      this.$refs.personInfo.forEach((element) =>
        checkResults.push(element.checkError())
      );

      checkResults.push(this.$refs.givewayInfo.checkError());

      const validateResult = checkResults.every((element) => element.result);

      if (!validateResult) {
        this.scrollToError(checkResults.map((result) => result.errorText));
      }

      return validateResult;
    },
    getLightRemainAmount(typeValue) {
      return this.lightInfo.find((element) => element.value === typeValue)
        .remainingAmount;
    },
    getLightCount(typeValue) {
      return (
        this.info.prayerList.filter((element) =>
          element.lightTypes.includes(typeValue)
        ).length || 0
      );
    },
    // 商業邏輯是否正確
    validateLogic() {
      let lightValidateErrorTypes = [];
      this.lightInfo
        .map((lightInfoConfig) => lightInfoConfig.value)
        .forEach((element) => {
          const lights = this.getLightCount(element);
          const lightsRemainAmount = this.getLightRemainAmount(element);
          const lightsValidation = lights <= lightsRemainAmount;
          if (false === lightsValidation) {
            lightValidateErrorTypes.push(element);
          }
        });
      this.$refs.personInfo.forEach((element) =>
        element.changeLightError(lightValidateErrorTypes)
      );

      return lightValidateErrorTypes.length === 0;
    },

    scrollToError(errorTexts) {
      let scrollFirstElement = true;
      // 畫面滾動到錯誤位置
      errorTexts.forEach((errorText, index) => {
        Object.keys(errorText).forEach((element) => {
          if (typeof errorText[element] === Object) {
            Object.keys(errorText[element]).forEach((subElement) => {
              if (errorText[element][subElement] !== '' && scrollFirstElement) {
                this.scrollToPrayer(element, index);
                scrollFirstElement = false;
              }
            });
          }
          if (errorText[element] !== '' && scrollFirstElement) {
            this.scrollToPrayer(element, index);
            scrollFirstElement = false;
          }
        });
      });
    },
    scrollToPrayer(element, index) {
      scrollToElement(`#${element}${index}`, {
        offset: window.innerWidth < 768 ? -100 : -190,
        ease: 'out-circ',
        duration: 500,
      });
    },
    getPrice() {
      let price = 0;
      this.info.prayerList.forEach((prayer) => {
        if (
          prayer.lightTypes != null &&
          prayer.lightTypes != undefined &&
          prayer.lightTypes.length > 0
        ) {
          prayer.lightTypes.forEach((light) => {
            this.lightInfo.forEach((lightConfig) => {
              if (light === lightConfig.value) {
                price = price + lightConfig.price;
              }
            });
          });
        }
      });

      return price;
    },
    getFare() {
      let fare = store.state.main.onlineStatus.lightInfo.givewayFare;
      let addrsMap = new Map();

      this.info.prayerList.forEach((prayer) => {
        if (
          prayer.givewayType === 2 &&
          prayer.givewayAddress != null &&
          prayer.givewayAddress != undefined
        ) {
          let address =
            prayer.givewayAddress.county.trim() +
            prayer.givewayAddress.town.trim() +
            prayer.givewayAddress.detail.trim();

          addrsMap.set(address);
        }
      });
      fare = fare * addrsMap.size;

      let result = addrsMap.size > 0 ? fare : 0;
      return result;
    },
    addPerson() {
      if (this.displayInfo.prayerList.length >= 9) {
        return;
      }

      this.displayInfo.prayerList.push({
        lightTypes: [],
        name: '',
        sex: '',
        birthDate: '',
        birthHour: '',
        phone: '',
        givewayType: 0,
        givewayName: '',
        address: {
          county: '',
          town: '',
          detail: '',
        },
        givewayAddress: {
          county: '',
          town: '',
          detail: '',
        },
      });
    },
    subPerson() {
      if (this.displayInfo.prayerList.length <= 1) {
        return;
      }

      this.displayInfo.prayerList.splice(
        this.displayInfo.prayerList.length - 1
      );
    },
    updateGiveway(data) {
      this.giveway = data;
    },
  },
  computed: {
    lightTips() {
      return store.state.main.onlineStatus.lightInfo.fanTaiSuiInfo || '';
    },
    displayInfo() {
      return this.applyInfo;
    },
    applyInfo() {
      return store.state.main.lightApplyInfo;
    },

    lightInfo() {
      var lightInfoList = [];
      lightInfoList = store.state.main.onlineStatus.lightInfo.lightList.map(
        (light) => {
          return {
            text: light.name,
            value: light.type,
            price: light.price,
            remainingAmount: light.remainingAmount,
            disabled: light.remainingAmount <= 0 ? true : false,
          };
        }
      );
      return lightInfoList;
    },
    givewayInfo() {
      var givewayList = [];
      givewayList = store.state.main.onlineStatus.lightInfo.givewayList
        .filter((giveway) => giveway.flag === 1)
        .map((giveway) => {
          return {
            text: giveway.givewayName,
            value: giveway.givewayPoint,
            givewayIndex: giveway.givewayIndex,
          };
        });
      return givewayList;
    },
  },
};
</script>

<style>
.light-apply {
  margin: 0px 5px 0px 5px;
  display: flow-root;
}
.light-footer-steps {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.light-footer-previous {
  margin-right: 15px;
}

.light-footer-next {
  margin-left: 15px;
}

.light3-tip {
  margin-top: 30px;
  font-size: 16px;
  color: black;
}
.light-person-btn {
  margin-top: 30px;
  align-items: center;
  display: flex;
  justify-content: center;
}
.light-person {
  height: 36px;
  width: auto;
  text-align: center;
  line-height: 36px;
  height: 36px;
  padding: 0px 20px 0px 20px;
  font-size: 14px;
  line-height: 36px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  color: black;
  border-color: black;
  border: 1px solid rgba(70, 70, 70, 0.8);
}
.light-person:hover {
  opacity: 0.5;
}

.light-person-add {
  margin-left: 10px;
}

.light-person-sub {
  margin-right: 10px;
}
.light-person-disable {
  opacity: 0.5;
  cursor: default;
}
.light-giveway {
  margin-top: 30px;
  margin-bottom: 30px;
}

@media (min-width: 768px) {
  .light-footer-steps {
    margin-top: 150px;
  }
}
</style>
